
export class UseMarkModel {

  /**
   * Ｐコード共通
   */
  // 受注コード
  public orderCode: string = <string>'';

  // Ｐコード
  public pCode: string = <string>'';

  /**
   * アイテムコードプロモーションマーク
   */
  // 供給促進マークコード
  public promoteMarkCode: string = <string>'';

  // 供給促進マーク（い）
  public promoteMark0: string = <string>'';

  // 供給促進マーク（と）
  public promoteMark1: string = <string>'';

  // 供給促進マーク（ぐ）
  public promoteMark2: string = <string>'';

  // 供給促進マーク（ち）
  public promoteMark3: string = <string>'';

  // 供給促進マーク（さ）
  public promoteMark4: string = <string>'';

  // 供給促進マーク（とう）
  public promoteMark5: string = <string>'';

  // 供給促進マーク（な）
  public promoteMark6: string = <string>'';

  // 供給促進マーク（に）
  public promoteMark7: string = <string>'';

  // 供給促進マーク（ク）
  public promoteMark8: string = <string>'';
}
